import React, { Component, createRef } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import LazyLoad from 'react-lazyload';
import Slider from 'react-slick';
import {
  Section,
  SectionHeader,
  Heading,
  Paragraph,
  Image,
  BackgroundImage,
} from 'components';
import { sliderData } from './logic';
import './Slider.scss';

class CareerSlider extends Component {
  constructor(props) {
    super(props);

    this.slider = createRef();

    this.state = {
      sliderSettings: {
        className: 'career-slider__container',
        speed: 1000,
        arrows: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  }

  renderImages = (images, loadedData) =>
    images.map((image, index) => (
      <div key={`logo-${index}`} className={'career-slider__icon'}>
        <Image
          src={loadedData[image].childImageSharp.fluid}
          alt={`Technology logo ${index + 1}`}
          style={{ objectFit: 'contain' }}
        />
      </div>
    ));

  renderItems = loadedData =>
    sliderData.map(item => {
      const {
        id,
        background,
        backgroundColor,
        content,
        description,
        color,
        images,
      } = item;

      return (
        <div key={content}>
          <div className={`section--${backgroundColor} career-slider__slide`}>
            {background && (
              <BackgroundImage
                src={loadedData[background].childImageSharp.fluid}
              />
            )}
            <Heading
              color={color}
              size={'big'}
              type={3}
              additionalClass={'career-slider__tile'}
            >
              {content}
            </Heading>
            <Paragraph
              additionalClass={'career-slider__paragraph'}
              color={color}
            >
              {description}
            </Paragraph>
            {images && (
              <div className={'career-slider__images'}>
                {this.renderImages(images, loadedData)}
              </div>
            )}
          </div>
        </div>
      );
    });

  render() {
    const { sliderSettings } = this.state;

    return (
      <StaticQuery
        query={graphql`
          fragment CareerSlider on File {
            childImageSharp {
              fluid(maxWidth: 61) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }

          query {
            Symfony: file(
              relativePath: { eq: "technology/logos/logo-symfony.png" }
            ) {
              ...CareerSlider
            }
            Java: file(
              relativePath: { eq: "technology/logos/logo-java.png" }
            ) {
              ...CareerSlider
            }
            Angular: file(
              relativePath: { eq: "technology/logos/logo-angular.png" }
            ) {
              ...CareerSlider
            }
            Python: file(
              relativePath: { eq: "technology/logos/logo-python.png" }
            ) {
              ...CareerSlider
            }
            Php: file(relativePath: { eq: "technology/logos/logo-php.png" }) {
              ...CareerSlider
            }
            Android: file(
              relativePath: { eq: "technology/logos/logo-android.png" }
            ) {
              ...CareerSlider
            }
            Spring: file(
              relativePath: { eq: "technology/logos/logo-spring.png" }
            ) {
              ...CareerSlider
            }
            Css: file(relativePath: { eq: "technology/logos/logo-css.png" }) {
              ...CareerSlider
            }
            Ios: file(relativePath: { eq: "technology/logos/logo-ios.png" }) {
              ...CareerSlider
            }
            React: file(
              relativePath: { eq: "technology/logos/logo-react.png" }
            ) {
              ...CareerSlider
            }
            NodeJS: file(
              relativePath: { eq: "technology/logos/logo-node.png" }
            ) {
              ...CareerSlider
            }
            Html: file(
              relativePath: { eq: "technology/logos/logo-html.png" }
            ) {
              ...CareerSlider
            }
            Teal: file(
              relativePath: { eq: "career/career-tile-tealspace.png" }
            ) {
              childImageSharp {
                fluid(maxWidth: 430) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            Design: file(relativePath: { eq: "career/career-design.png" }) {
              childImageSharp {
                fluid(maxWidth: 430) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `}
        render={loadedData => (
          <Section additionalClass={'career-slider'} color={'carrara'}>
            <SectionHeader size={'small'} headingType={2} lineColor={'yellow'}>
              What else makes
              <br />
              us different?
            </SectionHeader>
            <div className={'career-slider__wrapper'}>
              <LazyLoad once offset={200}>
                <Slider ref={this.slider} {...sliderSettings}>
                  {this.renderItems(loadedData)}
                </Slider>
              </LazyLoad>
            </div>
          </Section>
        )}
      />
    );
  }
}

export default CareerSlider;
